import React, { Suspense, useEffect } from "react";
import { useQuery, gql } from "@apollo/client";

import config from "./config.public";
import { UIContext, Loading } from "ui-core";

import graphql from "./graphql/index";

import * as auth from "./functions/auth";
import * as router from "./functions/router";

var client = graphql();
auth.authchange(client);

const authMutation = gql`
    mutation auth {
        auth @client
        monitor @client
    }
`;

client.mutate({ mutation: authMutation });

const rootQuery = gql`
    query getView {
        loading @client
        loggedIn @client
        myUID @client
        currentRoute @client
    }
`;

const App = (props) => {
    useEffect(() => {
        // Clears storage so persistent data tables reset on refresh
        sessionStorage.clear();
    }, []);

    const { data } = useQuery(rootQuery, {
        client,
    });

    // Handles loading case
    if (data === undefined || data.loading) {
        return (
            <UIContext.Provider value={config}>
                <Loading />
            </UIContext.Provider>
        );
    }

    // Main rendering
    return (
        <UIContext.Provider value={config}>
            {/* Base layer */}
            <Suspense key="suspense-container" fallback={<Loading />}>
                {router.load({ localData: data })}
            </Suspense>
        </UIContext.Provider>
    );
};

export default App;
